import React, { useState } from 'react';
import cn from "classnames";
import { isEmpty } from "lodash";
import ReactTooltip from "react-tooltip";
import { TableHeader } from "./TableHeader";
import { ItemRow } from "./ItemRow";
import Pagination from "../Pagination";
import {useSelector} from "react-redux";
import {suppliersLoadingSelector} from "../../../selectors/forms";
import {styles} from "../../../containers/goods/styles";
import Loader from "../../../components/utils/Loader";

const SuppliersList = ({ suppliers }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const suppliersLoadnig = useSelector(suppliersLoadingSelector);

    const sortedSuppliers = suppliers.sort((a, b) => {
        if (a.name && b.name) {
            return a.name.localeCompare(b.name);
        }
        return 0;
    });

    const pageCount = Math.ceil(sortedSuppliers.length / itemsPerPage);
    const offset = currentPage * itemsPerPage;
    const currentItems = sortedSuppliers.slice(offset, offset + itemsPerPage);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    const handlePageLimitChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(0);
    };

    return (
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }}>
            <div className="kt-portlet kt-portlet--mobile">
                <div className="kt-portlet__body kt-portlet__body--fit">
                    <div
                        style={{ position: 'relative', marginBottom: 0 }}
                        className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}
                    >
                        {suppliersLoadnig && (
                            <div style={styles.tableLoading}>
                                <Loader text="Загружаем поставщиков..." />
                            </div>
                        )}
                        <table className="kt-datatable__table" style={{ minHeight: '700px' }}>
                            <TableHeader />
                            <tbody className="kt-datatable__body">
                            {
                                isEmpty(currentItems)
                                    ? <tr>
                                        <td colSpan={8}><span
                                            className="kt-datatable--error">Поставщики не найдены</span></td>
                                    </tr>
                                    : currentItems.map((item) => <ItemRow key={item.id} item={item}/>)
                            }
                            </tbody>
                        </table>
                        <Pagination
                            pageCount={pageCount}
                            currentPage={currentPage}
                            onPageChange={handlePageClick}
                            itemsPerPage={itemsPerPage}
                            onItemsPerPageChange={handlePageLimitChange}
                            totalItems={sortedSuppliers.length}
                        />
                    </div>
                </div>
            </div>
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
};

export default SuppliersList;
